import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=23055924&scoped=true"
import script from "./quit.vue?vue&type=script&lang=js"
export * from "./quit.vue?vue&type=script&lang=js"
import style0 from "./quit.vue?vue&type=style&index=0&id=23055924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23055924",
  null
  
)

export default component.exports